
export const operationTypeValue = {
  INCREASE: 'INCREASE',
  DELETE: 'DELETE',
  UPDATE: 'UPDATE',
};
